// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"uR-z","categoryName":"vR-z","categoryNameSearchHeader":"wR-z","categoryContent":"xR-z","bottomAligned":"yR-z","image":"zR-z","imageNoBackground":"AR-z"};